import { Loader } from '@components/atoms/Loader';
import { ProductBenefit } from '@components/molecules/ProductBenefit';
import { ProductTile } from '@components/molecules/ProductTile';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Link from 'next-translate-routes/link';

import { generatePath, slugify, decodeKey } from '@utils/core';
import { translate } from '@utils/translations';
import { paths } from '@paths';

import * as S from './styles';
import { Benefit, IProps, Product } from './types';

function withBenefits(
  products: Product[],
  benefits: Benefit[]
): Array<Product | Benefit> {
  return products.reduce(
    (acc: Array<Product | Benefit>, cur: Product, i: number) => {
      benefits.forEach((benefit) => {
        const { offset } = benefit;
        const isOffsetI = i === offset;
        if (isOffsetI) {
          acc.push(benefit);
        }
      });

      acc.push(cur);
      return acc;
    },
    []
  );
}

export const ProductList: React.FC<IProps> = ({
  products,
  canLoadMore = false,
  loading = false,
  benefits,
  innerList = false,
  onLoadMore = (): null => null,
}: IProps) => (
  <>
    <S.List loading={loading || undefined}>
      {(benefits ? withBenefits(products, benefits) : products).map(
        (item, i) => {
          if (item.__typename === 'Product') {
            return (
              <Link
                href={generatePath(paths.product, {
                  slug: slugify(translate(item, 'name')),
                  id: decodeKey(item.id, 'Product'),
                })}
                key={item.id}
              >
                <a>
                  <ProductTile product={item} />
                </a>
              </Link>
            );
          }
          return <ProductBenefit key={i} {...item} />;
        }
      )}
    </S.List>
    {!innerList && (
      <>
        <S.BorderDiv />
        <S.Loader>
          {loading ? (
            <Loader />
          ) : (
            canLoadMore && (
              <S.List loading={loading}>
                <S.ShowMoreButton
                  className="showmore"
                  data-cy="load-more_button"
                  onClick={onLoadMore}
                >
                  <FormattedMessage defaultMessage="show more" id="IRPFF9" />
                </S.ShowMoreButton>
              </S.List>
            )
          )}
        </S.Loader>
      </>
    )}
  </>
);

ProductList.displayName = 'ProductList';
